import type { AnalysisCategory } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'
import type { AnalysesCategoryContextItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

const mapAnalysesCategory = (
  item: AnalysesCategoryContextItem,
  getHref: (_categoryTranslit: string) => string,
): AnalysisCategory => ({
  name: item.name,
  slug: item.service_category?.translit || '',
  icon: item.category_logo_image?.url || '',
  href: getHref(item.service_category?.translit) || '',
})

export default mapAnalysesCategory
